import { render, staticRenderFns } from "./TradeDetail.vue?vue&type=template&id=16644df3&scoped=true&"
import script from "./TradeDetail.vue?vue&type=script&lang=ts&"
export * from "./TradeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TradeDetail.vue?vue&type=style&index=0&id=16644df3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16644df3",
  null
  
)

export default component.exports